import { render, staticRenderFns } from "./FormHeading.vue?vue&type=template&id=6df2e52e&"
import script from "./FormHeading.vue?vue&type=script&lang=js&"
export * from "./FormHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports